export class ListThreatHuntingResultsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "results",
            "baseName": "results",
            "type": "Array<ThreatHuntingResult>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListThreatHuntingResultsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
